import * as React from "react";
import type { SVGProps } from "react";
const SvgClickCursor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 6c0 .55-.45 1-1 1s-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1zm-7 5c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1zm.31-6.11A.996.996 0 1 0 4.9 6.3l2.2 2.2c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-2.2-2.2zm9.895 3.91H16.2h.01zm.705-.29a1.02 1.02 0 0 1-.705.29.996.996 0 0 1-.705-1.7l2.2-2.2a.996.996 0 1 1 1.41 1.41zm-9.82 6.98-2.2 2.2a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l2.2-2.2a.996.996 0 1 0-1.41-1.41zm5.23-4.44 9 3v-.01c.38.13.65.48.68.88a1 1 0 0 1-.55.97l-3.7 1.85-1.85 3.7c-.17.34-.51.55-.89.55h-.07c-.41-.03-.75-.3-.88-.68l-3-9a.99.99 0 0 1 .24-1.02c.26-.27.66-.36 1.02-.24m3.78 5.51c.1-.2.26-.35.45-.45l1.84-.92-4.81-1.6 1.6 4.81z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgClickCursor;
